

import React, { useState, useEffect } from 'react';
import './VoiceGames';

const ColorPicker = () => {
  const [color, setColor] = useState('black');

  useEffect(() => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = new SpeechRecognition();
    recognition.continuous = true;
    recognition.interimResults = true;
    recognition.lang = 'en-US';

    recognition.onresult = (event) => {
      let finalTranscript = '';
      for (let i = event.resultIndex; i < event.results.length; ++i) {
        if (event.results[i].isFinal) {
          finalTranscript += event.results[i][0].transcript;
        }
      }
      if (finalTranscript) {
        setColor(finalTranscript);
         
      }
      
    };

    recognition.start();
    
    return () => recognition.stop();
  }, []);

//   const handleChangeColor = (event) => { setColor(event.target.value); // Update the state with the selected color
//   }

  return (
    <div>
      <h2>Color Picker</h2>
      {/* <input type="color" onChange={handleChangeColor} style={{ margin: '10px' }}/> */}
      {color}
      
      <div style={ {width: '100px', height: '100px',backgroundColor:color, margin: '0 auto'} }></div>
      
      
    </div>
  );
};

export default ColorPicker;


